import React from "react";
import ItemsListings from "../../Components/Items/ItemsListings";
import ItemsBreadCrumbs from "../../Components/Items/ItemsBreadCrumbs";

export default function ItemsListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <ItemsBreadCrumbs />
        <ItemsListings />
      </div>
    </React.Fragment>
  );
}
